import {
  CommunicationInstanceAllStatus,
  ICommunicationInstanceStatusMapping
} from '@120wateraudit/communications-types'
import { Badge } from '@120wateraudit/envirio-components'
import * as React from 'react'
import { GetCommunicationInstanceStatusMappingHOC } from 'src/hocs'

const CommunicationInstanceStatus = ({
  status,
  statusMappingJSON,
  statusMappingLoading = true
}: {
  status: CommunicationInstanceAllStatus
  statusMappingJSON?: string
  statusMappingLoading?: boolean
}) => {
  if (!statusMappingJSON || statusMappingLoading) {
    return <Badge variant="default">Loading...</Badge>
  }

  const statusMapping: ICommunicationInstanceStatusMapping =
    JSON.parse(statusMappingJSON)

  const { mappedStatusButtonVariants, statusMap } = statusMapping
  const possibleStatus = statusMap[status]
  if (!possibleStatus) {
    return <Badge variant="default">Unknown</Badge>
  }

  const mappedStatus = statusMap[status].mappedStatus
  const buttonVariant = mappedStatusButtonVariants[mappedStatus]
  return <Badge variant={buttonVariant}>{mappedStatus}</Badge>
}

export default GetCommunicationInstanceStatusMappingHOC(
  CommunicationInstanceStatus
)
